let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("47p8o")).then(() => parcelRequire('l5flR'));